<section class="exhibitorcontact">
  <div class="mdc-layout-grid no-offset-x no-offset-y">
    <div class="mdc-layout-grid__inner">
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
        <h2 class="mat-headline-2" i18n="@@featureExhibitorDetails-pageTabExhibitor-contact"> Kontakt </h2>
        <hr />
      </div>
    </div>
  </div>
  <div class="mdc-layout-grid no-offset-x">
    <div class="mdc-layout-grid__inner">
      <div
        class="contact__details mdc-layout-grid__cell mdc-layout-grid__cell--span-4-desktop mdc-layout-grid__cell--span-3-tablet mdc-layout-grid__cell--span-4-phone exhibitor-contact-address">
        {{ exhibitor?.name }}
        <br />
        @if (exhibitor?.address?.street || exhibitor?.address?.house_number) {
        {{ exhibitor?.address?.street }} {{ exhibitor?.address?.house_number }}
        <br />
        } @if (exhibitor?.address?.zip_code || exhibitor?.address?.city || exhibitor?.address?.country) {
        {{ exhibitor?.address?.zip_code }} {{ exhibitor?.address?.city }}
        @if (exhibitor?.address?.country) {
        <br />{{ exhibitor?.address?.country }}
        } }
        <br />
        <br />
        @if (exhibitor?.contact?.email || exhibitor?.contact?.phone || exhibitor?.contact?.fax) { @if
        (exhibitor?.contact?.email) {
        <a
          href="mailto:{{ exhibitor?.contact?.email }}"
          analyticsLinkType="MAIL_COMPANY"
          class="contact__link"
          [attr.analyticsContext]="
            [
              {
                schema: snowplowIglu.entity_exhibitor,
                data: {
                  context: exhibitor?.fair_id,
                  locale: locale,
                  exhibitor_id: exhibitor?.id,
                  exhibitor_name: exhibitor?.name
                }
              }
            ] | json
          "
          (middleclick)="trackClick($event.currentTarget, 'MAIL_COMPANY', exhibitor?.contact?.email)"
          (click)="trackClick($event.currentTarget, 'MAIL_COMPANY', exhibitor?.contact?.email)">
          <mat-icon>mail</mat-icon>
          <span>{{ exhibitor?.contact?.email }}</span></a
        >
        } @if (exhibitor?.contact?.phone) {
        <a
          href="tel:{{ exhibitor?.contact?.phone }}"
          class="contact__link"
          (middleclick)="trackClick($event.currentTarget, 'TELEPHONE_COMPANY', exhibitor?.contact?.phone)"
          (click)="trackClick($event.currentTarget, 'TELEPHONE_COMPANY', exhibitor?.contact?.phone)">
          <mat-icon>phone_in_talk</mat-icon>
          <span>{{ exhibitor?.contact?.phone }}</span></a
        >
        } @if (exhibitor?.contact?.fax) {
        <a
          href="tel:{{ exhibitor?.contact?.fax }}"
          class="contact__link"
          (middleclick)="trackClick($event.currentTarget, 'FAX_COMPANY', exhibitor?.contact?.fax)"
          (click)="trackClick($event.currentTarget, 'FAX_COMPANY', exhibitor?.contact?.fax)"
          ><mat-icon>fax</mat-icon> <span>{{ exhibitor?.contact?.fax }}</span></a
        >
        } @if ( exhibitor?.links || exhibitor?.homepage || objectRef.keys(exhibitor?.social_media ?? {}).length > 0 ) {
        <br />
        } } @if (exhibitor?.homepage) {
        <a
          [href]="exhibitor?.homepage"
          class="contact__link"
          target="_blank"
          rel="noopener nofollow"
          analyticsLinkType="HOMEPAGE_COMPANY"
          (middleclick)="trackClick($event.currentTarget, 'HOMEPAGE_COMPANY', exhibitor?.homepage)"
          (click)="trackClick($event.currentTarget, 'HOMEPAGE_COMPANY', exhibitor?.homepage)">
          <mat-icon>globe</mat-icon>
          <span i18n="@@featureExhibitorDetails-pageTabExhibitor-toHomepage">Zur Homepage</span>
        </a>
        }
      </div>
      <div
        class="contact__details mdc-layout-grid__cell mdc-layout-grid__cell--span-4-desktop mdc-layout-grid__cell--span-2-tablet mdc-layout-grid__cell--span-4-phone exhibitor-contact-links"></div>
      @if (hasSocialMedia || hasEMail) {
      <div
        class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4-desktop mdc-layout-grid__cell--span-3-tablet mdc-layout-grid__cell--span-4-phone exhibitor-contact-socials">
        @if (hasEMail) {
        <div *ngIf="showSendBusinessCard" class="direct-contact">
          <div i18n="@@featureExhibitorDetails-pageTabExhibitor-businessCardContact">
            Sie möchten von {{ exhibitor?.name }} kontaktiert werden?
          </div>
          <bau365-send-business-card-button
            class="button"
            [fairId]="exhibitor?.fair_id"
            [exhibitorId]="exhibitor?.id"></bau365-send-business-card-button>
        </div>
        } @if (hasSocialMedia) {
        <ng-container i18n="@@featureExhibitorDetails-pageTabExhibitor-social">
          Erleben Sie {{ exhibitor?.name }} auch auf Social Media
        </ng-container>
        <div class="social-list">
          @if (exhibitor?.social_media?.linked_in) {
          <div class="social-list-item">
            <a
              [href]="exhibitor?.social_media?.linked_in"
              (middleclick)="trackClick($event.currentTarget, 'SOCIAL_MEDIA_COMPANY', 'LINKED_IN')"
              (click)="trackClick($event.currentTarget, 'SOCIAL_MEDIA_COMPANY', 'LINKED_IN')"
              target="_blank"
              rel="noopener nofollow">
              <mat-icon svgIcon="social-linkedin"></mat-icon>
            </a>
          </div>
          } @if (exhibitor?.social_media?.xing) {
          <div class="social-list-item">
            <a
              [href]="exhibitor?.social_media?.xing"
              (middleclick)="trackClick($event.currentTarget, 'SOCIAL_MEDIA_COMPANY', 'XING')"
              (click)="trackClick($event.currentTarget, 'SOCIAL_MEDIA_COMPANY', 'XING')"
              target="_blank"
              rel="noopener nofollow">
              <mat-icon svgIcon="social-xing"></mat-icon>
            </a>
          </div>
          } @if (exhibitor?.social_media?.instagram) {
          <div class="social-list-item">
            <a
              [href]="exhibitor?.social_media?.instagram"
              (middleclick)="trackClick($event.currentTarget, 'SOCIAL_MEDIA_COMPANY', 'INSTAGRAM')"
              (click)="trackClick($event.currentTarget, 'SOCIAL_MEDIA_COMPANY', 'INSTAGRAM')"
              target="_blank"
              rel="noopener nofollow">
              <mat-icon svgIcon="social-instagram"></mat-icon>
            </a>
          </div>
          } @if (exhibitor?.social_media?.facebook) {
          <div class="social-list-item">
            <a
              [href]="exhibitor?.social_media?.facebook"
              (middleclick)="trackClick($event.currentTarget, 'SOCIAL_MEDIA_COMPANY', 'FACEBOOK')"
              (click)="trackClick($event.currentTarget, 'SOCIAL_MEDIA_COMPANY', 'FACEBOOK')"
              target="_blank"
              rel="noopener nofollow"
              analyticsLinkType="SOCIAL_MEDIA_COMPANY">
              <mat-icon svgIcon="social-facebook"></mat-icon>
            </a>
          </div>
          } @if (exhibitor?.social_media?.twitter) {
          <div class="social-list-item">
            <a
              [href]="exhibitor?.social_media?.twitter"
              (middleclick)="trackClick($event.currentTarget, 'SOCIAL_MEDIA_COMPANY', 'X')"
              (click)="trackClick($event.currentTarget, 'SOCIAL_MEDIA_COMPANY', 'X')"
              target="_blank"
              rel="noopener nofollow"
              analyticsLinkType="SOCIAL_MEDIA_COMPANY">
              <mat-icon svgIcon="social-x"></mat-icon>
            </a>
          </div>
          } @if (exhibitor?.social_media?.youtube) {
          <div class="social-list-item">
            <a
              [href]="exhibitor?.social_media?.youtube"
              (middleclick)="trackClick($event.currentTarget, 'SOCIAL_MEDIA_COMPANY', 'YOUTUBE')"
              (click)="trackClick($event.currentTarget, 'SOCIAL_MEDIA_COMPANY', 'YOUTUBE')"
              target="_blank"
              rel="noopener nofollow"
              analyticsLinkType="SOCIAL_MEDIA_COMPANY">
              <mat-icon svgIcon="social-youtube"></mat-icon>
            </a>
          </div>
          } @if (exhibitor?.social_media?.pinterest) {
          <div class="social-list-item">
            <a
              [href]="exhibitor?.social_media?.pinterest"
              (middleclick)="trackClick($event.currentTarget, 'SOCIAL_MEDIA_COMPANY', 'PINTEREST')"
              (click)="trackClick($event.currentTarget, 'SOCIAL_MEDIA_COMPANY', 'PINTEREST')"
              target="_blank"
              rel="noopener nofollow"
              analyticsLinkType="SOCIAL_MEDIA_COMPANY">
              <mat-icon svgIcon="social-pinterest"></mat-icon>
            </a>
          </div>
          } @if (exhibitor?.social_media?.tiktok) {
          <div class="social-list-item">
            <a
              [href]="exhibitor?.social_media?.tiktok"
              (middleclick)="trackClick($event.currentTarget, 'SOCIAL_MEDIA_COMPANY', 'TIKTOK')"
              (click)="trackClick($event.currentTarget, 'SOCIAL_MEDIA_COMPANY', 'TIKTOK')"
              target="_blank"
              rel="noopener nofollow"
              analyticsLinkType="SOCIAL_MEDIA_COMPANY">
              <mat-icon svgIcon="social-tiktok"></mat-icon>
            </a>
          </div>
          }
        </div>
        }
      </div>
      }
    </div>
  </div>
</section>
